import { render, staticRenderFns } from "./ExamUpdate.vue?vue&type=template&id=0f0b74fe"
import script from "./ExamUpdate.vue?vue&type=script&lang=js"
export * from "./ExamUpdate.vue?vue&type=script&lang=js"
import style0 from "./ExamUpdate.vue?vue&type=style&index=0&id=0f0b74fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports